<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="cart" active="cart"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-input v-model="filter.client_id" size="small" class="w200" style="width:133px;" placeholder="client_id"></el-input>
          <el-input v-model="filter.client_ip" size="small" class="w200" style="width:133px" placeholder="client_ip"></el-input>
          <el-select v-model="filter.content_require" size="small" style="width:200px;" placeholder="content require">
            <el-option v-for="item in content_require_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="fr">
          <el-button size="small" @click="redirect('/orders/diy-create')"
            >作品浏览</el-button
          >
        </div>
      </div>

      <div>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
        <el-table
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="44"> </el-table-column>
          <el-table-column label="client" width="222"> 
            <template slot-scope="scope">
              <div>
                <span class="gray-color">client_id:</span>
                <span>{{scope.row.client_id}}</span>
              </div>
              <div>
                <span class="gray-color">client_ip:</span>
                <span>{{scope.row.client_ip}}</span>
              </div>
            </template>
          </el-table-column>


          <el-table-column label="cart_record" min-width="888"> 
            <template slot-scope="scope">
              <el-table
              :data="scope.row.cart_record"
              v-loading="loading"
              style="width: 100%"
              ref="multipleTable"
              tooltip-effect="dark"
              border
              >
                <el-table-column label="sku" width="222"> 
                  <template slot-scope="scope">
                    <div style="text-align:center;">
                      <el-image
                        style="width: 88px;"
                        :src="scope.row.shopify_variant_info.image_src"
                        :preview-src-list="[scope.row.shopify_variant_info.image_src]"
                      >
                      </el-image>
                      <div>{{ scope.row.shopify_variant_info.price }} x {{ scope.row.quantity }}</div>
                      <div><a :href="'https://casedraw.com/products/' + scope.row.shopify_variant_info.product_id" target="_blank">{{ scope.row.shopify_variant_info.title }}</a></div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="upload_list" max-width="200"> 
                  <template slot-scope="scope">
                    <div v-if="scope.row.file_list && scope.row.file_list.length>0">
                      <div>
                        <el-image
                          v-for="(ff, index_ff) in scope.row.file_list"
                          :key="index_ff"
                          style="width: 66px;"
                          :src="ff.file_oss"
                          :preview-src-list="[ff.file_oss]"
                        >
                        </el-image>
                      </div>
                      <div>{{scope.row.input1}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="auto_design" max-width="200"> 
                  <template slot-scope="scope">
                      <el-image
                        v-if="scope.row.auto_design"
                        style="width: 66px;"
                        :src="scope.row.auto_design.image_draw"
                        :preview-src-list="[scope.row.auto_design.image_draw]"
                      >
                      </el-image>
                  </template>
                </el-table-column>
                <el-table-column label="diy_result" max-width="200"> 
                  <template slot-scope="scope">
                    <div v-if="scope.row.diy_result">
                        <el-image
                          style="width: 66px;"
                          :src="scope.row.diy_result.image_diy"
                          :preview-src-list="[scope.row.diy_result.image_draw]"
                        >
                        </el-image>
                        <div>{{scope.row.design_line_item.diy_result.model_name}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="ctime" prop="ctime" width="222"> </el-table-column>
            </el-table>
            </template>
          </el-table-column>


        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>


    </div>
  </div>
</template>

<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
export default {
  components: {
    "v-head": head,
    "v-left": left,
  },
  data() {
    return {
      loading: false,
      popName: null,
      pop_diy_info: null,
      edit_row: null,
      edit_order_goods_row: null,
      multipleSelection: [],
      filter: {
        page: 1,
        size: 20,
        app_id:"",
        keyword: "",
        client_id:"",
        client_ip: "",
        action_name: "",
        button_name:"",
        page_name:"",
        time_range: [],
      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      order_step_options: [
        { value: 1, label: "未付款" },
        { value: 2, label: "已付款" },
        { value: 3, label: "已生产" },
        { value: 4, label: "已发货" },
        { value: 5, label: "已售后" },
        { value: 6, label: "已完成" },
        { value: 7, label: "已取消" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toPopProduce(row) {
      this.popName = "pop_produce";
      this.edit_row = row;
    },
    toPopDrag(sub) {
      if (sub.diy_info) {
        this.popName = "pop_drag";
        this.pop_diy_info = sub.diy_info;
      }
    },
    exportExcel() {
      this.$http.post("/orders/export/export", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          window.location.href = res.data.file_oss;
        }
      });
    },
    getList() {
      this.loading = true;
      this.$http.post("/v1/pri/statics/cart-list", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/cart/Index.vue